<template>
    <modal
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="onCloseModal"
        :closeBtn="closeBtn"
        position="left"
        size="full"
        class="cemeteries-search"
    >
        <template v-slot:content>
            <div class="row content">
                <div class="col-12">
                    <form autocomplete="false"
                        :data-vv-scope="vScope"
                        @submit.prevent="() => {return false;}">
                        <div class="row justify-content-between">
                            <div class="col-12 col-sm-7 col-xl-5">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        id="input-cemetery_id"
                                        name="cemetery_id"
                                        label="name"
                                        v-model.trim="form.cemetery_id"
                                        :options="cemeteries"
                                        :multiple="true"
                                        v-validate="''"
                                        :data-vv-scope="vScope"
                                    >
                                        {{ $t(`${modelTranslateID}.cemetery.title`) }}
                                    </MaterialSelect>
                                </div>
                            </div>
                            <div class="col col-sm-auto d-flex align-items-center">
                                <div class="search-actions form-group">
                                    <button
                                        type="button"
                                        class="search-filter-action btn btn-sm btn-block m-sm-0"
                                        :aria-label="`filter`"
                                        @click.prevent="onShowFilter(selectedTab)">
                                        <span class="button-wrapper">
                                            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                                <path d="M2.5 12H5.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M11.5 12H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M17.5 18.5H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M2.5 18.5H11.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M2.5 5.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M20.5 5.5H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M16.5 7.5C17.6046 7.5 18.5 6.60457 18.5 5.5C18.5 4.39543 17.6046 3.5 16.5 3.5C15.3954 3.5 14.5 4.39543 14.5 5.5C14.5 6.60457 15.3954 7.5 16.5 7.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M7.5 14C8.60457 14 9.5 13.1046 9.5 12C9.5 10.8954 8.60457 10 7.5 10C6.39543 10 5.5 10.8954 5.5 12C5.5 13.1046 6.39543 14 7.5 14Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path d="M13.5 20.5C14.6046 20.5 15.5 19.6046 15.5 18.5C15.5 17.3954 14.6046 16.5 13.5 16.5C12.3954 16.5 11.5 17.3954 11.5 18.5C11.5 19.6046 12.3954 20.5 13.5 20.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                            <span class="filter-text">{{ $t(`global.filters`) }}</span>
                                        </span>
                                        <span v-if="numFilters" class="badge badge-pill">{{ numFilters }}</span>
                                    </button>
                                    <button
                                        v-if="allowAdd"
                                        type="button"
                                        class="search-add-action btn btn-sm btn-block btn-main btn-rounded m-sm-0"
                                        :aria-label="`add`"
                                        @click.prevent="onAdd(selectedTab)">
                                        <div class="button-wrapper">
                                            <i class="fas fa-plus"></i>
                                            <span>{{ textAddButton }}</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <ul
                                    class="nav nav-tabs mb-3"
                                    role="tablist"
                                >
                                    <li
                                        v-for="(tab, index) in activeTabs"
                                        :key="`tab-${index}`"
                                        class="nav-item"
                                    >
                                        <a
                                            class="nav-link"
                                            :class="{ active: selectedTab.id == tab.id }"
                                            data-toggle="tab"
                                            role="tab"
                                            :id="`item-${tab.id}-tab`"
                                            href="javascript:void(0);"
                                            :aria-controls="`item-${tab.id}`"
                                            :aria-selected="selectedTab.id == tab.id"
                                            @click.prevent="activeTab = tab"
                                        >
                                            {{ $t(tab.name) }}
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div
                                        v-for="tab in activeTabs"
                                        :key="`tab-pane-${tab.id}`"
                                        class="tab-pane fade"
                                        :class="{ 'show active': selectedTab.id == tab.id }"
                                        role="tabpanel"
                                        :id="`item-${tab.id}`"
                                        :aria-labelledby="`item-${tab.id}-tab`"
                                    >
                                        <SearchTableElement
                                            :ref="`search-${tab.id}`"
                                            :key="`search-${tab.id}`"
                                            :isShow="selectedTab.id == tab.id"
                                            :moduleCode="tab.moduleCode"
                                            :mapId="mapId"
                                            :panelId="tab.panelId"
                                            :baseTranslateID="tab.baseTranslateID"
                                            :eventViewDetail="tab.eventViewDetail"
                                            :vScope="tab.vScope"
                                            :tableColumns="tab.tableColumns"
                                            :tableSettings="tab.tableSettings"
                                            :tableClass="tab.tableClass"
                                            :tableStartLoad="tab.tableStartLoad"
                                            v-model="tab.tableFilters"
                                            @searched="onSearched"
                                            @close="onCloseModal"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <SearchFilterPanel
                v-if="filterPanel.show"
                :showModal="filterPanel.show"
                :panelId="filterPanel.panelId"
                :baseTranslateID="filterPanel.baseTranslateID"
                :filters="filterPanel.filters"
                :lists="filterPanel.lists"
                :readonlyForm="readonlyForm"
                @apply="onApplyFilter"
                @cancel="onCancelFilter"
                @close="onCloseFilter"
            />
        </template>
    </modal>
</template>

<script>
import ButtonControlMixin from '@/components/maps/mixins/ButtonControlMixin';
import { toCamelCase, deepClean, dotNotation, mergeDeep, isArray } from "@config/utils";
import { EVENTS } from "../shared/config";

const PREFIX_PANELID = 'search_';
function initialLists(){
    return {
        [`${PREFIX_PANELID}default`]: {
            loaded: false,
            cemeteries: [],
        },
        [`${PREFIX_PANELID}sectors`]: {
            loaded: false,
            actions: {},
            types: [],
        },
        [`${PREFIX_PANELID}occupations`]: {
            loaded: false,
            actions: {},
            types: [],
            states: [],
            positions: [],
            directions: [],
        },
        [`${PREFIX_PANELID}interments`]: {
            loaded: false,
            actions: {},
            types: [],
            containers: [],
            genders: [],
            religions: [],
            causes_death: [],
        },
        [`${PREFIX_PANELID}entities`]: {
            loaded: false,
            actions: {},
            genders: [],
            religions: [],
            causes_death: [],
        },
    };
}

let lists = initialLists();

export default {
    name: "searchCemeteriesControl",
    mixins: [
        ButtonControlMixin
    ],
    components: {
        Modal: () => import(/* webpackChunkName: "modal-data" */ "@/app/shared/components/modals/ModalData"),
        ColumnActions: () => import(/* webpackChunkName: "column-actions" */ "@/app/shared/components/tables/ColumnActions"),
        TableSearch: () => import(/* webpackChunkName: "table-data" */ "@/app/shared/components/tables/DataTable"),
        SearchTableElement: () => import(/* webpackChunkName: "cemeteries-searchtableelement" */ "./../components/search/elements/SearchTableElement"),
        SearchFilterPanel: () => import(/* webpackChunkName: "cemeteries-searchfilterpanel" */ "./../components/search/SearchFilterPanel"),
    },
    props: {
        mapId: {
            type: String,
            default: null,
        },
        closeBtn: {
            type: Boolean,
            default: true
        },
    },
    data() {
        let pageID = "search";
        return {
            idPanel: pageID,
            baseTranslateID: pageID,
            className: "ol-filters",
            loaded: false,
            showContent: false,
            vScope: "form",
            readonlyForm: false,
            labelDateFormat: "DD/MM/YYYY",
            activeTab: null,
            allowAdd: false,
            form: {
                cemetery_id: null,
                [`${PREFIX_PANELID}sectors`]: {
                    number: null,
                    sector_type_id: null,
                },
                [`${PREFIX_PANELID}occupations`]: {
                    sector: {
                        number: null,
                    },
                    row: null,
                    number: null,
                    occupation_type_id: null,
                    occupation_state_type_id: null,
                    occupation_direction_type_id: null,
                    occupation_position_type_id: null,
                },
                [`${PREFIX_PANELID}interments`]: {
                    interment_number: null,
                    interment_at: null,
                    interment_type_id: null,
                    container_type_id: null,
                    occupation: {
                        sector: {
                            number: null,
                        },
                        row: null,
                        number: null,
                    },
                    entity: {
                        name: null,
                        birth_at: null,
                        death_at: null,
                        gender_id: null,
                        cause_death_type_id: null,
                        religion_type_id: null,
                        age: {
                            from: null,
                            to: null
                        }
                    }
                },
                [`${PREFIX_PANELID}entities`]: {
                    name: null,
                    phone: null,
                    birth_at: null,
                    death_at: null,
                    gender_id: null,
                    cause_death_type_id: null,
                    religion_type_id: null,
                    age: {
                        from: null,
                        to: null
                    }
                }
            },
            filterPanel: {
                show: false,
                panelId: null,
                baseTranslateID: null,
                filters: {},
                lists: {},
            }
        };
    },
    beforeDestroy() {
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`;
        },
        modelTranslateID() {
            return `${this.translateID}.model`
        },
        showModal() {
            return this.isActive && this.isPanelVisible;
        },
        tabsConfig() {
            let items = [];

            let key = 'sectors';
            items.push({
                key: key,
                default: true,
                status: true,
                order: 1,
                eventViewDetail: EVENTS.SHOW_MODAL_DETAIL_SECTOR,
                tableColumns: [
                    {
                        label: `${key}.model.code`,
                        field: "code",
                        field_label: "code_simple",
                        sortable: true,
                        class: "text-nowrap",
                        actionTitle: `${key}.buttons.view_data`,
                        actionPermissionName: 'allowViewDetail',
                        actionFnName: 'onViewDetail'
                    },
                    {
                        label: `${key}.model.cemetery`,
                        field: "cemetery.name",
                        field_label: "cemetery",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: `${key}.model.number`,
                        field: "number",
                        sortable: true,
                        class: "text-nowrap text-center",
                    },
                    {
                        label: `${key}.model.sector_type`,
                        field: "sector_type.name",
                        field_label: "type",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: "",
                        field: null,
                        class: "text-nowrap actions"
                    }
                ],
                tableSettings: {
                    sort: "asc",
                    order_by: "code",
                    queryParams: {
                        filters: 'data',
                    },
                },
            });

            key = 'occupations';
            items.push({
                key: key,
                default: false,
                status: true,
                order: 1,
                eventViewDetail: EVENTS.SHOW_MODAL_DETAIL_OCCUPATION,
                tableColumns: [
                    {
                        label: `${key}.model.code`,
                        field: "code",
                        field_label: "code_simple",
                        sortable: true,
                        class: "",
                        actionTitle: `${key}.buttons.view_data`,
                        actionPermissionName: 'allowViewDetail',
                        actionFnName: 'onViewDetail'
                    },
                    {
                        label: `${key}.model.cemetery`,
                        field: "sector.cemetery.name",
                        field_label: "cemetery",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: `${key}.model.sector`,
                        field: "sector.name",
                        field_label: "sector",
                        sortable: true,
                        class: "text-nowrap text-center",
                    },
                    {
                        label: `${key}.model.row`,
                        field: "row",
                        sortable: true,
                        class: "text-nowrap text-center",
                    },
                    {
                        label: `${key}.model.number`,
                        field: "number",
                        sortable: true,
                        class: "text-nowrap text-center",
                    },
                    {
                        label: `${key}.model.occupation_type`,
                        field: "occupation_type.name",
                        field_label: "type",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: `${key}.model.occupation_state_type`,
                        field: "occupation_state_type.name",
                        field_label: "state",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: `${key}.model.interments`,
                        field: "interments",
                        sortable: false,
                        class: "text-center",
                    },
                    {
                        label: `${key}.model.burials_capacity_abbr`,
                        field: "burials_capacity",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.entombment_capacity_abbr`,
                        field: "entombment_capacity",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.cremation_capacity_abbr`,
                        field: "cremation_capacity",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: "",
                        field: null,
                        class: "text-nowrap actions"
                    }
                ],
                tableSettings: {
                    sort: "asc",
                    order_by: "code",
                    queryParams: {
                        filters: 'data',
                    },
                },
                tableFilters: {sector: {cemetery_id: this.form.cemetery_id}},
                tableClass: 'table-responsive table-values-nowrap',
            });

            key = 'interments';
            items.push({
                key: key,
                default: false,
                status: true,
                order: 1,
                eventViewDetail: EVENTS.SHOW_MODAL_DETAIL_INTERMENT,
                tableColumns: [
                    {
                        label: `${key}.model.occupation`,
                        field: "occupation.code",
                        field_label: "occupation",
                        sortable: true,
                        class: "text-nowrap text-center",
                    },
                    {
                        label: `${key}.model.cemetery`,
                        field: "occupation.sector.cemetery.name",
                        field_label: "cemetery",
                        sortable: true,
                        class: "",
                    },
                    {
                        label: `${key}.model.entity.name`,
                        field: "entity.name",
                        sortable: true,
                        class: "",
                        actionTitle: `${key}.buttons.view_data`,
                        actionPermissionName: 'allowViewDetail',
                        actionFnName: 'onViewDetail'
                    },
                    {
                        label: `${key}.model.entity.last_known_address`,
                        field: "entity.full_address",
                        sortable: false,
                        class: "",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.entity.gender`,
                        field: "entity.gender.name",
                        field_label: "entity.gender",
                        sortable: true,
                        class: "text-nowrap",
                    },
                    {
                        label: `${key}.model.entity.birth_at`,
                        field: "entity.birth_at",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.entity.death_at`,
                        field: "entity.death_at",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.entity.age`,
                        field: "entity.age",
                        sortable: false,
                        class: "text-center",
                    },
                    {
                        label: `${key}.model.entity.religion`,
                        field: "entity.religion_type.name",
                        field_label: "entity.religion",
                        sortable: true,
                        class: "",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.entity.cause_death`,
                        field: "entity.cause_death_type.name",
                        field_label: "entity.cause_death",
                        sortable: true,
                        class: "",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.interment_number`,
                        field: "interment_number",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.interment_at`,
                        field: "interment_at",
                        sortable: true,
                        class: "text-center",
                        nowrap: false,
                    },
                    {
                        label: `${key}.model.interment_type`,
                        field: "interment_type.name",
                        field_label: "interment_type",
                        sortable: true,
                        class: "",
                        nowrap: false,
                    },
                    {
                        label: "",
                        field: null,
                        class: "text-nowrap actions"
                    }
                ],
                tableSettings: {
                    sort: "desc",
                    order_by: "interment_at",
                    queryParams: {
                        filters: 'data',
                    },
                },
                tableFilters: {occupation: {sector: {cemetery_id: this.form.cemetery_id}}},
                tableClass: 'table-responsive table-values-nowrap',
            });

            key = 'entities';
            items.push({
                key: key,
                default: false,
                status: true,
                order: 1,
                eventViewDetail: EVENTS.SHOW_MODAL_DETAIL_ENTITY,
                tableColumns: [
                    {
                        label: `${key}.model.name`,
                        field: "name",
                        sortable: true,
                        class: "text-left",
                        actionTitle: `${key}.buttons.view_data`,
                        actionPermissionName: 'allowViewDetail',
                        actionFnName: 'onViewDetail'
                    },
                    {
                        label: `${key}.model.address`,
                        field: "full_address",
                        sortable: false,
                        class: "",
                    },
                    {
                        label: `${key}.model.birth_at`,
                        field: "birth_at",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        label: `${key}.model.death_at`,
                        field: "death_at",
                        sortable: true,
                        class: "text-center",
                    },
                ],
                tableSettings: {
                    sort: "asc",
                    order_by: "name",
                    queryParams: {
                        filters: 'data',
                    },
                },
            });

            return items;
        },
        tabs() {
            let tabs = [];
            this.tabsConfig.forEach((tab, index) => {
                let key = tab.key;
                let panelId = `${PREFIX_PANELID}${key}`;
                tabs.push({
                    id: key,
                    name: this.$t(`${this.baseTranslateID}.tabs.${key}`),
                    moduleCode: this.moduleCode,
                    panelId: panelId,
                    baseTranslateID: key,
                    vScope: this.vScope,
                    eventViewDetail: tab.eventViewDetail,
                    tableColumns: tab.tableColumns,
                    tableSettings: tab.tableSettings,
                    tableClass: tab.tableClass ?? 'table-responsive-sm',
                    // tableFilters: tab.tableFilters,
                    // [TODO] ver porque esta linha origina o reload de todos os elementos: sectors, occupations...e por isso é necessário usar o equalDeep
                    tableFilters: Object.assign({}, mergeDeep(this.form[panelId], tab.tableFilters ?? {cemetery_id: this.form.cemetery_id})),
                    tableStartLoad: tab?.default ?? false,
                    default: tab?.default ?? false,
                    active: tab?.status ?? true,
                    order: tab.order ?? 1,
                });
            });

            let tabDefault = tabs.find(t => t.default) ?? (tabs.length ? tabs[0] : null);
            if(tabDefault) {
                tabDefault.tableStartLoad = true;
            }

            tabs.sort((a, b) => a.order - b.order);
            return tabs;
        },
        activeTabs() {
            return this.tabs.filter(t => t.active);
        },
        selectedTab() {
            return this.activeTab || this.activeTabs.find(t => t.default) || (this.activeTabs.length ? this.activeTabs[0] : {}) || {};
        },
        currentElement(){
            let refKey = this.selectedTab ? `search-${this.selectedTab.id}` : null;
            let elem = this.$refs[refKey] ?? null;
            // it's because the ref sits within a v-for loop. Vue changes the ref to an array, ^
            // because there could be multiple elements being referenced. Likewise, when the the ref sits within the component,
            // each component has its own scope, so its a single ref, rather than an array.
            return isArray(elem) && elem.length ? elem[0] : null;
        },
        textAddButton() {
            return this.$t(`${this.selectedTab?.baseTranslateID}.title`);
        },
        numFilters() {
            let _filters = this.selectedTab ? this.form[this.selectedTab.panelId] : {};
            return Object.keys(dotNotation(deepClean(_filters))).filter(x => !x.toLowerCase().endsWith('enddate')).length;
        },
        cemeteries() {
            return lists[`${PREFIX_PANELID}default`]['cemeteries'];
        },
    },
    methods: {
        initialize() {
            if (this.showContent) {
                return;
            }
            this.loadLists()
            .then(() => {
                this.showContent = true;
            });
        },
        addButtonMap(_map) {
            let btn = _map.createBtnImg(
                this.assetsPathTheme("/map/filter.svg"),
                _map.getControlClassName(this.orderClassName),
                this.title,
                [
                    {
                        type: "click",
                        event: evt => {
                            this.openPanel();
                            evt.stopPropagation();
                        }
                    }
                ],
                this.lblBtn
            );
            _map.addControl(this.posBtnMap, btn);
            return btn;
        },
        onCloseModal() {
            this.closeModal();
        },
        closeModal() {
            this.closePanel();
        },
        async loadLists(panelId = `${PREFIX_PANELID}default`) {
            let typeLists = `lists${toCamelCase(panelId.replace(new RegExp(`^${PREFIX_PANELID}`),''), true)}`;
            let url = this.url.hasOwnProperty(typeLists) ? this.url[typeLists] : null;
            if (url && !lists[panelId].loaded) {
                return await this.$http.get(url)
                    .then(({ data }) => {
                        Object.keys(data).forEach(key => {
                            if (key in lists[panelId]) {
                                lists[panelId][key] = data[key];
                            }
                        });
                        lists[panelId].loaded = true;
                    })
                    .catch(error => {
                        lists[panelId].loaded = false;
                        this.showHttpError(error);
                    })
                    .finally(() => {});
            }
            return Promise.resolve(true);
        },
        async getLists(panelId, subtype = null) {
            return await this.loadLists(panelId)
            .then(() => {
                let _lists = lists[panelId] ?? {};
                return subtype ? (_lists.hasOwnProperty(subtype) ? _lists[subtype] : []) : _lists;
            });
        },
        onAdd(tab) {
            if(!this.allowAdd) return;

            let eventViewDetail = tab.eventViewDetail;
            if(eventViewDetail) {
                this.$eventBus.publish(
                    this.moduleCode,
                    eventViewDetail,
                    {
                        data: {},
                        callback:  (params = {}) => {
                            let elem = this.currentElement;
                            if(elem) {
                                elem.callbackViewDetail(params);
                            }
                        }
                    }
                );
            }
        },
        onShowFilter(tab) {
            let _panelId = tab.panelId;
            this.getLists(_panelId)
            .then(() => {
                this.filterPanel.panelId = _panelId;
                this.filterPanel.baseTranslateID = tab.baseTranslateID;
                this.filterPanel.lists = lists[_panelId];
                this.filterPanel.filters = this.form[_panelId];
                this.filterPanel.show = true;
            })
        },
        onApplyFilter(params = {}) {
            const {panelId, form = {}} = params;
            this.form[panelId] = Object.assign({}, this.form[panelId], form);
            this.filterPanel.show = false;
        },
        onCancelFilter() {
            this.filterPanel.show = false;
        },
        onCloseFilter() {
            Object.assign(this.$data.filterPanel, this.$options.data().filterPanel);
        },
        onSearched(params = {}) {
            const {panelId, actions = {}} = params;
            lists[panelId]['actions'] = actions;
            this.allowAdd = lists[panelId]?.actions?.create ?? false;
        },
    },
    watch: {
        showModal(value) {
            if (value) {
                this.initialize();
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.search-actions {
    display: flex;
    gap:10px;

    .search-filter-action {
        color: var(--primary-color);
        min-width: auto;
        position: relative;

        &:active,
        &:focus,
        &:hover {
            outline: 0;
            box-shadow: none;
            text-decoration: none;
        }

        .button-wrapper {
            display: flex;
            align-items: center;
            -ms-flex-align: center;
            gap: 8px;

            svg {
                background-repeat: no-repeat;
                display: inline-block;
                height: 24px;
                width: 24px;
            }

            .filter-text {
                font-size: .95rem;
                line-height: 1;
                text-transform: uppercase;
            }
        }

        .badge {
            position: absolute;
            text-align: center;
            display: inline-block;
            border-radius: 50%;
            transition: transform .2s ease-in-out;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            pointer-events: none;
            right: 75px;
            top: -6px;
            font-size: 10px;
            font-weight: 300;
            width: 19px;
            height: 17px;
            line-height: 1;
            padding: 0.4em;
            background-color: var(--primary-color);
            color: #ffffff;
        }
    }

    .search-add-action {
        .button-wrapper {
            display: flex;
            align-items: center;
            -ms-flex-align: center;
            font-size: .95rem;
            gap: 8px;
        }
    }
}
</style>

<style lang="scss">
.city-table-wrapper {
    .table.table-values-nowrap {
        tbody {
            tr td,
            tr td a,
            tr td span,
            tr td button {
                max-width: 220px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>